import image1 from '@/assets/images/event1.jpg';
import image2 from '@/assets/images/event2.png';
import image3 from '@/assets/images/event3.png';
import image4 from '@/assets/images/event4.png';

import { fromNow, ONE_DAY } from '../helpers';

export default [
  {
    title: '8. Alumni Stammtisch',
    image: image1,
    location: 'Schäbige Eckkneipe in Lehe',
    content: `Wie jedes Jahr findet auch 2018 wieder unser Stammtisch statt.
    Freue mich über alle die auf ein (oder zwei, oder sieben) Bierchen vorbeikommen!`,
    usergroup: 'Alumni',
    date: fromNow(),
    id: '05e53bc1-176c-4c6b-be3f-ab943172297b',
    attending: undefined,
  },
  {
    title: 'Show Your Work!',
    image: image4,
    location: 'Haus T - HS Bremerhaven',
    usergroup: 'Alumni',
    date: fromNow(-ONE_DAY),
    id: '6d6e6e80-8f10-4fe5-9f8b-30ee8ec20354',
    attending: undefined,
  },
  {
    title: 'Bremerhaven läuft!',
    image: image3,
    location: 'Bürgerpark Bremerhaven',
    usergroup: 'Alle',
    date: fromNow(ONE_DAY * 3),
    id: '72d1c641-6485-4b16-90fd-7494331be909',
    attending: true,
  },
  {
    title: 'Seminargruppe 4',
    image: image2,
    location: 'Co-Working Space Alte Bürger',
    usergroup: 'Studierende',
    date: fromNow(-(ONE_DAY * 6)),
    id: '11e15eab-d2e2-4cdd-94da-7111b1dce573',
    attending: undefined,
    username: 'jonaskuske',
  },
  {
    title: 'AstA Event vom Feinsten',
    image: image4,
    location: 'AstA - HS Bremerhaven',
    usergroup: 'Studierende',
    date: 1527841547211,
    id: 'cc11a027-bb29-480e-b05e-dfc6cd5ad0e2',
    attending: false,
  },
  {
    title: 'Middenmang',
    image: image2,
    location: 'Nachtschicht Bremerhaven',
    usergroup: 'Alumni',
    date: fromNow(ONE_DAY * 8),
    id: 'd9dffddd-2adb-4eaf-b99f-61bb8d10c3a6',
    attending: undefined,
    username: 'carloscholz',
  },
  {
    title: 'Public Viewing - WM 2018',
    image: image1,
    location: 'Wencke Docks (gutes Wetter)',
    usergroup: 'Alle',
    date: fromNow(-(ONE_DAY * 21)),
    id: '0fb11543-4e87-4037-81fa-ee13d5c038c9',
    attending: true,
    username: 'jonaskuske',
  },
];
